import { MenuItem } from '@cloudclevr/components';
import {
  useAddDashboardTile,
  useDashboardUpdateTileParams,
  useRemoveDashboardTile,
} from '@hooks/dashboard';
import { useLicencesOverassignedQuery } from '@hooks/licenses';
import { useState } from 'react';

import { DashboardTiles } from '@common/constants';
import { TilesProps } from '@common/types';
import { NumberTile } from '@pages/InsightsAndAnalytics/tiles/NumberTile';

type Params = {
  vendorList: string[];
};

export const OverassignedLicensesSnapshot: React.FC<TilesProps> = ({
  params,
  id,
  classNames,
}) => {
  const [parameters, setParameters] = useState<Params>(JSON.parse(params));
  const { removeMenuItem } = useRemoveDashboardTile(id);
  const { addMenuItem } = useAddDashboardTile(
    DashboardTiles.OverassignedLicensesSnapshot,
    parameters
  );
  const isOnDashboardPage = !!id;
  const useDashboardUpdateTileParamsMutation = useDashboardUpdateTileParams();

  const {
    data: licencesOverassignedData,
    isLoading: isLicencesOverassignedLoading,
    refetch,
  } = useLicencesOverassignedQuery(parameters);

  const handleDropdown = (value: string[]) => {
    setParameters({
      vendorList: value,
    });

    if (isOnDashboardPage) {
      useDashboardUpdateTileParamsMutation.mutate({
        params: JSON.stringify({
          vendorList: value,
        }),
        tileId: id,
      });

      refetch();
    }
  };

  const sortMenuItems: MenuItem[] = [
    {
      id: '1',
      label: 'All Vendors',
      value: 'All',
      action: () => handleDropdown(['Microsoft', 'RingCentral']),
    },
    {
      id: '2',
      label: 'Microsoft',
      value: 'Microsoft',
      action: () => handleDropdown(['Microsoft']),
    },
    {
      id: '3',
      label: 'RingCentral',
      value: 'RingCentral',
      action: () => handleDropdown(['RingCentral']),
    },
  ];

  return (
    parameters && (
      <NumberTile
        classNames={'col-span-6 md:col-span-3 xl:col-span-2'}
        sortData={sortMenuItems}
        contextData={isOnDashboardPage ? removeMenuItem : addMenuItem}
        dropdownMenuItemClasses={'!w-[300px]'}
        headerTitle={'Overassigned licenses: Snapshot'}
        initialSelectedItem={sortMenuItems.find(
          (item) =>
            item.value ===
            (parameters.vendorList.length > 1
              ? 'All'
              : parameters.vendorList[0])
        )}
        isLoading={isLicencesOverassignedLoading}
        data={
          licencesOverassignedData
            ? Object.values(licencesOverassignedData)
            : []
        }
        buttonLabel=""
      />
    )
  );
};
